String.prototype.toPersianDigits = function () {
    var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return this.replace(/[0-9]/g, function (w) {
        return id[+w];
    });
};


export function enToFa(string) {
    return string.toPersianDigits();
}

export function randomNum(min,max){
    return Math.floor(Math.random() * max) + min;
}
